import type { ComponentProps } from 'svelte';
import { createWidgetSingleton } from '../create-widget-singleton';
import StandaloneChat from './StandaloneChat.svelte';

export interface WidgetConfig {
	apiKey: string;
	containerId?: string;
	baseUrl?: string;
	model?: string;
	initialMessage?: string;
	chatPlaceholder?: string;
	cssPath?: string; // Path to widget.css, defaults to auto-detection
}

// Global BotbakeryWidget API - singleton that manages widget instances
export const BotbakeryWidget = createWidgetSingleton<ComponentProps<typeof StandaloneChat>>(
	StandaloneChat,
	'botbakery-chat-widget',
	'widget'
);
